<div class="modal-close" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon>
  <span>{{ "btn:close" | translate }}</span>
</div>

<div class="modal-header">
  <h4 class="modal-title">{{ "game:create:title" | translate }}</h4>
</div>

<div class="modal-body">

  <!-- Identifier -->
  <div class="row mb-3">
    <div class="col-12">
      <label class="modal-label">{{ "game:create:identifier" | translate }} <span class="text-danger">*</span></label>
      <input
        [(ngModel)]="form.identifier"
        class="input-box w-100"
        type="text"
        placeholder="{{ 'game:create:identifier:placeholder' | translate }}"
      />
      <small *ngIf="identifierInvalid" class="text-danger d-block mt-1">{{ "game:create:identifier:invalid" | translate }}</small>
    </div>
  </div>

  <!-- Row: Languages + Allow free sample -->
  <div class="row mb-3">
    <div class="col-6">
      <label class="modal-label d-block mb-2">{{ "game:create:languages" | translate }} <span class="text-danger">*</span></label>
      <div class="form-check" *ngFor="let code of langCodes">
        <input class="form-check-input" type="checkbox" [id]="'lang-' + code" [(ngModel)]="languages[code]" />
        <label class="form-check-label" [for]="'lang-' + code">{{ ("language:options:" + code) | translate }}</label>
      </div>
    </div>

    <div class="col-6">
      <label class="modal-label d-block mb-2">{{ "game:create:allow_free_sample" | translate }} <span class="text-danger">*</span></label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="sample-yes" name="freeSample" [value]="true" [(ngModel)]="form.free_sample" />
        <label class="form-check-label" for="sample-yes">{{ "Yes" | translate }}</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="sample-no" name="freeSample" [value]="false" [(ngModel)]="form.free_sample" />
        <label class="form-check-label" for="sample-no">{{ "No" | translate }}</label>
      </div>
    </div>
  </div>

  <!-- Row: Type + Price -->
  <div class="row mb-3">
    <div class="col-6">
      <label class="modal-label d-block mb-1">{{ "game:create:type" | translate }} <span class="text-danger">*</span></label>
      <select class="pure-input w-100" [(ngModel)]="form.type">
        <option value="">{{ "game:create:type:placeholder" | translate }}</option>
        <option *ngFor="let opt of typeOptions" [value]="opt">{{ opt | titlecase }}</option>
      </select>
    </div>
    <div class="col-6">
      <label class="modal-label d-block mb-1">{{ "game:create:price" | translate }} <span class="text-danger">*</span></label>
      <input
        [ngModel]="form.price"
        (ngModelChange)="form.price = $event"
        (input)="form.price = $any($event.target).value === '' ? '' : +$any($event.target).value"
        class="input-box form-control"
        type="number"
        placeholder="{{ 'game:create:price:placeholder' | translate }}"
      />
      <small *ngIf="priceInvalid" class="text-danger d-block mt-1">{{ "game:create:price:invalid" | translate }}</small>
    </div>
  </div>

</div>

<div class="modal-footer">
  <div class="form-group clearfix">
    <button [disabled]="!isValid() || loadSpin" (click)="save()" type="button" class="btn btn-primary float-right ms-2 fs-15">
      <fa-icon class="mr-2" [icon]="faCircleNorch" *ngIf="loadSpin" [spin]="true"></fa-icon>
      {{ "game:create:btn:save" | translate }}
    </button>
  </div>
</div>
